<template>
    <vue-recaptcha
        ref="recaptcha"
        class="d-inline-block captcha-component captcha-recaptcha"
        @verify="onVerify"
        @expired="onExpired"
        @render="onRender"
        :sitekey="sitekey"
        :loadRecaptchaScript="true"
        :language="language"
        >
    </vue-recaptcha>
</template>

<script>
export default {
    props: {
        sitekey: {
            type: String,
            required: true,
        },
        language: {
            type: String,
            required: true,
        },
        captchaId: {
            type: String,
            required: false,
            default: null,
        },
    },

    components: {
        VueRecaptcha: () => import(/* webpackChunkName: "chunk-vue-recaptcha" */ 'vue-recaptcha').then((m) => m.VueRecaptcha),
    },

    data: function(){
        return  {
            validResponse: null,
            isRendered: false,
        };
    },

    created() {
        this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId, value: false});
        this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
    },

    beforeDestroy() {
        this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId, value: false});
        this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
    },

    methods: {
        onVerify: function (response) {
            // console.log('Verify: ' + response);
            this.validResponse = response;
            this.$store.dispatch("ui/recaptcha/setResponse", {response, recaptchaId: this.captchaId});
        },
        onExpired: function () {
            // console.log('Expired');
            this.validResponse = null;
            this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
        },
        onRender: function () {
            // console.log('Rendered');
            this.isRendered = true;
            this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId});
        },
        reset: function () {
            this.$refs.recaptcha.reset();
            this.onExpired();
        },
    },
    mounted: function () {
      console.log("setting capctha component");
      this.$store.dispatch("ui/recaptcha/setCaptchaComponent", this);
    }
}
</script>
